module.exports = __webpack_public_path__ + "media/img/Landing_Page/s2u-cta-02-dc524ed49142884fe9709b493c5d8a5b.jpg";